import FormField from "./FormField";

export default class BooleanField extends FormField {
    constructor(initialValue = false) {
        super(true, initialValue);
    }

    defaultValue() {
        return false;
    }
}
